import './index.scss';

// 升级图标：type 为功能类型，site 为升级来源位置
const UpgradeSingleIcon = ({ type = 'LLmsTxt', site = 'llms_txt', upgradeModal }) => {
    const handleUpgrade = () => {
        if (upgradeModal) {
            upgradeModal(1, type, site);
        }
    };

    return (
        <span className="upgrade_single_icon" onClick={handleUpgrade}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3ZM10.5303 5.96973C10.2374 5.67683 9.76262 5.67683 9.46973 5.96973L6.96973 8.46973C6.67683 8.76262 6.67683 9.23738 6.96973 9.53027C7.26262 9.82317 7.73738 9.82317 8.03027 9.53027L9.25 8.31055V13.5C9.25 13.9142 9.58579 14.25 10 14.25C10.4142 14.25 10.75 13.9142 10.75 13.5V8.31055L11.9697 9.53027C12.2626 9.82317 12.7374 9.82317 13.0303 9.53027C13.3232 9.23738 13.3232 8.76262 13.0303 8.46973L10.5303 5.96973Z" fill="var(--color-primary)" />
            </svg>
        </span>
    );
};

export default UpgradeSingleIcon;
